// Func = limiting Scope for this file
//get default
var mainTitle = document.title;
var mainDesc = document.querySelector("meta[name=description]").content;
var topp;

// header src 
var heroSrc = '';
//var canvasH = 960;
//var canvasW = canvasH * (1.23);



function closeMenu(){
	document.getElementById('menuCta').classList.remove('open')
	document.getElementById('menuCta').getElementsByClassName('text')[0].innerHTML = 'MENU'
	document.getElementById('headerMenu').classList.remove('open')
	document.getElementById('headerMenu').classList.add('close')

	setTimeout(function(){
		document.getElementById('headerMenu').classList.remove('close')
	}, 500);

	if(window.innerWidth < 700){
		document.getElementsByTagName('body')[0].classList.remove('overhide');
	}
}

// Scrollable function

function single_one_page(window) {

	var headerHeight = 100;

	var path = window.location.pathname.substr(1);

	if (path !== '') {

		console.log( path );

		var container = document.getElementById(path);
		if(container){
			var elementTop = container.offsetTop;

			window.scrollTo(0, elementTop - headerHeight);
			window.history.pushState({ pageTitle: container.getAttribute('data-title') }, '', '/' + container.id );
			document.title = container.getAttribute('data-title');
		}
		
	}

	var links = document.querySelectorAll('.LinkScroll');

	links.forEach(function (link) {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			if(window.innerWidth < 600){
				closeMenu()
			}

			
			var to = link.getAttribute('href');
			console.log(to);
			
			var element = document.querySelector(to);
			var elementTop = element.offsetTop;

			window.scrollTo(0, elementTop - headerHeight);
			window.history.replaceState({ pageTitle: element.getAttribute('data-title') }, '', '/' + to );
			document.title = element.getAttribute('data-title');
			document.querySelector("meta[name=description]").content = element.getAttribute('data-desc');

			return false;
		});
	});

	function isInViewport(elem) {
		var bounding = elem.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	
	window.addEventListener('scroll', function () {
		var containers = document.querySelectorAll('.LinkScrollContainer');
		if(!(window.ActiveXObject) && "ActiveXObject" in window){
			topp= document.documentElement.scrollTop
		} else {
			topp = window.pageYOffset
		}
		if(topp < 50){
			document.title = mainTitle;
			document.querySelector("meta[name=description]").content = document.querySelector("meta[name=description]").content;
			window.history.pushState({ pageTitle: mainTitle }, '', '/' )
		} else {
			containers.forEach(container => {
				if (isInViewport(container)) {
					window.history.pushState({ pageTitle: container.getAttribute('data-title') }, '', '/' + container.id )
		
					document.title = container.getAttribute('data-title');
					document.querySelector("meta[name=description]").content = container.getAttribute('data-desc');
				} 
			})
		}
		
	});
};

(function(){

	// RESTAURANT MENUS FILTER MOBILE
	document.querySelectorAll('.restMenus_filterMobile select').forEach((filter, i) => {
		filter.addEventListener('change', _ => {
			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( filter.value === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) {
			let eventChange = document.createEvent('HTMLEvents');
			eventChange.initEvent('change', true, false);
			filter.dispatchEvent(eventChange);
		}
	});

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	if ( window.location.pathname.substr(1) !== 'menus' ) {
		//draw hero logo
		heroSrc = document.getElementsByClassName('hero-img')[0].getElementsByTagName('img')[0].getAttribute('src');
		//animation();
		drawflower(heroSrc,1180,960, 0);

		// Scrollable function
		single_one_page(window);
	}

	setTimeout(function(){
		document.getElementById('start-content').classList.add('ready')
		document.getElementById('header').classList.add('ready')
	}, 500)

	//menu burger
	document.getElementById('menuCta').addEventListener('click', function(){
		if(!document.getElementById('menuCta').classList.contains('open')){
			document.getElementById('menuCta').classList.add('open')
			document.getElementById('menuCta').getElementsByClassName('text')[0].innerHTML = 'CLOSE'
			document.getElementById('headerMenu').classList.add('open')
			if(window.innerWidth < 700){
				document.getElementsByTagName('body')[0].classList.add('overhide');
			}
		} else {
			closeMenu()
		}
	});

	document.getElementById('closeMenu').addEventListener('click', function(){
		closeMenu()
	});

	//header back btn
	if(document.getElementsByClassName('backdalmar').length > 0){
		document.getElementsByClassName('backdalmar')[0].classList.add('ready');
	}

	//h1 and h2 titles
	if ( window.location.pathname.substr(1) !== 'menus' ) {
		document.getElementsByTagName('h1')[0].getElementsByTagName('span')[0].innerHTML = '<strong>' + document.getElementsByTagName('h1')[0].getElementsByTagName('span')[0].innerHTML + '</strong>';
		var h2t = document.getElementsByTagName('h2');
		for(var i = 0; i < h2t.length ; i++){
			if(h2t[i].getElementsByTagName('span').length > 0){
				h2t[i].getElementsByTagName('span')[0].innerHTML = '<strong>' + h2t[i].getElementsByTagName('span')[0].innerHTML + '</strong>';
			}
		}
	}
	//btn
	var btn = document.getElementsByClassName('btn');
	for(var i = 0; i < btn.length; i++){
		btn[i].innerHTML = '<span>' + btn[i].innerHTML + '</span>';
	}

	//change privacy
	document.getElementById('email-signup').getElementsByTagName('a')[0].setAttribute('href','https://www.thedalmar.com/privacy-policy')


	$(document).ready(function () {
		

		//footer mobile
		$('window').resize(function(){
			if($(window).width() < 600 ){
				$('footer .info').insertAfter($('footer .form'));
			}
		});
		if($(window).width() < 600 ){
			$('footer .info').insertAfter($('footer .form'));
		}

		
		
	});


	//parallax
	if(window.innerWidth > 600){
		if ( window.location.pathname.substr(1) !== 'menus' ){
			var rellax = new Rellax('.rellax');
		}
	} else{
		//home-menus
		if(document.getElementById('menus')){
			const menus = document.getElementById('menus').querySelectorAll('.item');
			menus.forEach( function(e){
					let FirstChild = e.childNodes[1];
					let LastChild = e.childNodes[3];
					e.insertBefore(LastChild, FirstChild);
				}
			)
		}
		
		
	}

	

}());
//animate to
function animateto(target){
	var gotoTarget = document.getElementById(target).offsetTop - 100 
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()
  
	//time interval
	var timer = setInterval(function() {
	  var time = new Date().getTime() - start
  
	  if(from <= to ){
		  var y = easeInOutQuart(time, from, to - from, duration)
	  } else {
		  
		  var y = easeInOutQuart(time, from, -(from - to), duration)
	  }
	  window.scrollTo(0, y)
	  if (time >= duration) clearInterval(timer)
  
	}, 1000 / 60);
   
	window.scrollTo(0, from)
   
}
//hero animation
//animate to
function animation(){
	let imgH = 2845;
	//let imgW = imgH * (1.23);
	let fullstart = new Date().getTime();
	let fullduration = 1700; 
	let fulltime;
	let result = 2845;
	//time interval
	let timeInterval = setInterval(function() {
		fulltime = new Date().getTime() - fullstart
		result = easeInOutQuart(fulltime, imgH, -(imgH - 760), fullduration);
		//drawflower(heroSrc, 960,760,200);
		drawflower(heroSrc,(result * (1.23)),result, 200);

		if (fulltime >= fullduration) clearInterval(timeInterval);

	}, 1000 / 60);
   
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

    	
